function hexToRGB(hex) {
    hex = hex.replace('#', '');

    if (hex.length === 3) {
        hex = hex
            .split('')
            .map(char => char + char)
            .join('');
    } else if (hex.length !== 6) {
        hex = '4383c4';
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `${r}, ${g}, ${b}`;
}

const darkenRGB = (rgb, factor) => {
    const [r, g, b] = rgb.split(',').map(Number);

    const clampFactor = Math.max(0, Math.min(1, factor));

    const darkenedR = Math.round(r * (1 - clampFactor));
    const darkenedG = Math.round(g * (1 - clampFactor));
    const darkenedB = Math.round(b * (1 - clampFactor));

    return `${darkenedR}, ${darkenedG}, ${darkenedB}`;
};

export const getTheme = apiData => {
    const {
        BACKGROUND_COLOR = '',
        TEXT_COLOR = '',
        FONT_FAMILY = '',
    } = apiData;

    const PartnerTheme = {
        primary: hexToRGB(BACKGROUND_COLOR),
        primaryDark: darkenRGB(hexToRGB(BACKGROUND_COLOR), 0.1),
    };

    const colors = {
        primary: `rgba(${PartnerTheme.primary}, 1)`,
        primary_hover: `rgba(${PartnerTheme.primaryDark}, 1)`,
        primary_shade_01: `rgba(${PartnerTheme.primary}, 0.05)`,
        primary_shade_02: `rgba(${PartnerTheme.primary}, 0.08)`,
        primary_shade_03: `rgba(${PartnerTheme.primary}, 0.6)`,
        primary_shade_04: `rgba(${PartnerTheme.primary}, 0.2)`,
        secondary: TEXT_COLOR,
        secondary_light: '#444',
        blue: '#0F53B9',
        gray: '#c1c1c1',
        gray_shade_01: '#e3e3e3',
        gray_shade_02: '#999',
        gray_shade_03: '#DFDFDF',
        gray_shade_04: '#F1F2F2',
        gray_shade_05: '#828283',
        gray_shade_06: '#666666',
        gray_shade_07: '#444',
        red: '#F50808',
        white: '#fff',
    };

    const theme = {
        palette: {
            primary: {
                main: colors.primary,
                mainHover: colors.primary_hover,
                background: colors.primary_shade_01,
                componentBG: colors.primary_shade_02,
                listItemHover: colors.primary_shade_02,
                listItemBorderHover: colors.primary_shade_03,
                loaderBG: colors.primary_shade_03,
                dropDownSelected: colors.primary_shade_04,
                disable: colors.primary_shade_03,
                statusDisable: colors.gray_shade_03,
                text: colors.secondary,
                textLighter: colors.secondary_light,
                placeholder: colors.gray,
                inputBorder: colors.gray,
                disableGray: colors.gray_shade_01,
                disableGrayText: colors.gray_shade_02,
                error: colors.red,
                iconHover: colors.gray_shade_01,
                expanderHeader: colors.gray_shade_04,
                replyUnreadCheckIcon: colors.gray_shade_05,
                replyReadCheckIcon: colors.blue,
                replyInfoText: colors.gray_shade_06,
                modalContentBG: colors.white,
            },
            secondary: {
                main: '#2bbccc',
            },
            success: {
                main: '#66bd06',
            },
            warning: {
                main: 'rgba(194,100,114,0.73)',
            },
            info: {
                main: '#6b2bcc',
            },
            error: {
                main: '#8d0509',
            },
            white: {
                main: '#ffffff',
            },
            screen: {
                desktop: '550px',
                smallScreen: '100%',
            },
            fontFamily: FONT_FAMILY,
        },
    };

    return theme;
};
